// Retorna el header con token incluido
export function header(user, contentType = "application/json") {
  
    return new Headers({
      "Authorization": "Bearer " + (user ? user.token : ""),
      "Content-Type": contentType,
    });
  }
  